import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { lastOrders } from "../../libs/Atoms";


export default function OrderAliasSaver({ orderId, orderHash }) {
  const [orders, setOrders] = useRecoilState(lastOrders);

  useEffect(() => {
    let currentSaves = Object.keys(orders)
    localStorage.lastOrder = orderHash;
    
    if (currentSaves.includes(orderId)) {

    } else {
      if (currentSaves.length > 5) {
        setOrders({ [orderId]: orderHash });
      } else {
        setOrders({ ...orders, [orderId]: orderHash });
      }

    }
  }, [orderHash])

  return null
}